module.exports = __webpack_public_path__ + "img/computer3.334df0b1.png";